import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';
import { useAuth } from './AuthContext';

const FavoritesContext = createContext();

export function FavoritesProvider({ children }) {
  const { userId } = useAuth();
  const [favorites, setFavorites] = useState([]); 

  useEffect(() => {
    if (!userId) return;
    api.get(`/favoritos/${userId}`, { withCredentials: true })
      .then(res => {
        if (res.data.success) {
          const idsVar = res.data.data.map(fav => fav.id_variacao);
          setFavorites(idsVar);
        }
      })
      .catch(console.error);
  }, [userId]);

  async function toggleFavorite({ id_usuario, id_variacao }) {
    if (favorites.includes(id_variacao)) {
      await api.delete('/favoritos', {
        data: { id_usuario, id_variacao },
        withCredentials: true
      });
      setFavorites(prev => prev.filter(x => x !== id_variacao));
    } else {
      await api.post('/favoritos', { id_usuario, id_variacao }, { withCredentials: true });
      setFavorites(prev => [...prev, id_variacao]);
    }
  }

  return (
    <FavoritesContext.Provider value={{ favorites, toggleFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  return useContext(FavoritesContext);
}